import SymptomsCheckerScreen from './SymptomsCheckerScreen';

export default SymptomsCheckerScreen;
